export const BASE_PATH = '/payments' as const

const PAY_PROVIDER_PATH = `${BASE_PATH}/appeal` as const

export const PaymentsAppealsPaths =  {
    id: `${PAY_PROVIDER_PATH}/:id` as const,
    } as const

export type PaymentsAppealsPathsType = typeof PaymentsAppealsPaths
